import * as Yup from "yup";

export const dataModel = {
  batchUuid: "",
  culture: "",
  varietyUuid: "",
  articleUuid: "",
  locationUuid: "",
  sectorUuid: "",
  viveroUuid: "",
  status: "ACTIVE",
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      batchUuid: Yup.string().required("forms.validations.required"),
      culture: Yup.string().required("forms.validations.required"),
      varietyUuid: Yup.string().required("forms.validations.required"),
      viveroUuid: Yup.string().required("forms.validations.required"),
      articleUuid: Yup.string().required("forms.validations.required"),
      locationUuid: Yup.string().required("forms.validations.required"),
      sectorUuid: Yup.string().optional("forms.validations.required"),
      status: Yup.string().required("forms.validations.required"),
    });
  }

  return Yup.object().shape({
    batchUuid: Yup.string().required("forms.validations.required"),
    culture: Yup.string().required("forms.validations.required"),
    varietyUuid: Yup.string().required("forms.validations.required"),
    viveroUuid: Yup.string().required("forms.validations.required"),
    articleUuid: Yup.string().required("forms.validations.required"),
    locationUuid: Yup.string().required("forms.validations.required"),
    sectorUuid: Yup.string().optional("forms.validations.required"),
    status: Yup.string().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
